import { useCallback, type RefObject } from "react";
import { toast } from "sonner";
import { acceptErrorMessage, doesFileMatchAccept } from "@/utils/file-accept";

interface UseAcceptedFileSelectOptions {
  accept: string;
  inputRef?: RefObject<HTMLInputElement>;
  onFileSelect: (file: File) => void;
}

export const useAcceptedFileSelect = ({
  accept,
  inputRef,
  onFileSelect,
}: UseAcceptedFileSelectOptions) => {
  return useCallback(
    (file: File | null | undefined) => {
      if (!file) return;

      if (!doesFileMatchAccept(file, accept)) {
        toast.error(acceptErrorMessage(accept));
        if (inputRef?.current) {
          inputRef.current.value = "";
        }
        return;
      }

      onFileSelect(file);
    },
    [accept, onFileSelect],
  );
};
